import type { RouteCustomer } from "./types";

const escapeCsv = (value: string | number) => {
  const text = String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const buildReadingsCsv = (
  readingDate: string,
  customers: RouteCustomer[],
  readings: Record<string, string>,
) => {
  const rows = [
    ["検針日", "順番", "顧客番号", "氏名", "検針結果"],
    ...customers.map((customer) => [
      readingDate,
      customer.order,
      customer.customerNumber,
      customer.name,
      readings[customer.id]?.trim() || "0",
    ]),
  ];

  return `\uFEFF${rows
    .map((row) => row.map((value) => escapeCsv(value)).join(","))
    .join("\r\n")}`;
};

export const createCsvFile = (
  readingDate: string,
  customers: RouteCustomer[],
  readings: Record<string, string>,
) => {
  const csv = buildReadingsCsv(readingDate, customers, readings);
  const filename = `kensin_${readingDate.replaceAll("-", "")}.csv`;
  return new File([csv], filename, {
    type: "text/csv;charset=utf-8",
  });
};
